import { NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";

@Component({
  selector: "tpm-buffer-card",
  templateUrl: "buffer-card.component.html",
  styleUrls: ["buffer-card.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, TranslateModule, CardModule, EneButtonModule]
})
export class BufferCardComponent {
  @Output() readonly newsButtonClicked = new EventEmitter<void>();
}
